import { keepPreviousData, useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { getFiatTransactions } from '../fiatTransactionsEndpoints'
import { fiatTransactionKeys } from '../fiatTransactionsQueryKeys'
import type { GetFiatTransactionsParams } from '../../types/fiatTransactionsTypes'

const DEFAULT_PAGE = 1
const DEFAULT_LIMIT = 20

export function useFiatTransactionsListQuery(
  filters: MaybeRefOrGetter<Partial<GetFiatTransactionsParams>>,
) {
  return useQuery({
    queryKey: () => fiatTransactionKeys.list(toValue(filters)),
    queryFn: () =>
      getFiatTransactions({
        page: DEFAULT_PAGE,
        limit: DEFAULT_LIMIT,
        ...toValue(filters),
      }),
    placeholderData: keepPreviousData,
  })
}
